import { defineComponent as _defineComponent } from 'vue'
import { nanoid } from 'nanoid'
import { twMerge } from 'tailwind-merge'
import {
  computed,
  inject,
  ref,
  toRef,
  onMounted,
  onUnmounted,
  watchEffect,
  reactive,
} from 'vue'
import { storeToRefs } from 'pinia'

import { useCommandStore } from './useCommandStore'
import { groupOptionsInjectionKey, optionsInjectionKey } from './utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'CommandItem',
  props: {
    value: null,
    tags: null,
    twClass: null
  },
  emits: ['select'],
  setup(__props: any, { emit }) {

const props = __props as {
  /** A unique value to identify the item */
  value: string
  /** Used for filtering to provide additional values that are included by the filtering */
  tags?: string[]
  /** Custom classes to apply to the 'items' element. */
  twClass?: string
};

const SELECT_EVENT = `cmd-item-select`





const { shouldFilter, storeId } = inject(optionsInjectionKey, {
  shouldFilter: true,
  storeId: '',
})

const commandStore = useCommandStore(storeId)
const { value: selected, filtered, isSearching } = storeToRefs(commandStore)

const itemRef = ref<HTMLDivElement>()

const groupOptions = inject(groupOptionsInjectionKey)
if (!groupOptions) {
  throw new Error(
    'Unknown group option, did you forget to wrap <CommandItem> inside a <CommandGroup>?',
  )
}
const itemId = `cmd-item-${nanoid()}`
const item = reactive({
  itemId,
  groupId: groupOptions.groupId,
  excludeFromFilter: groupOptions.excludeFromFilter,
  label: '',
  tags: props.tags ?? [],
  value: props.value,
})
const label = toRef(item, 'label')

watchEffect(() => {
  label.value = itemRef.value?.textContent?.trim().toLowerCase() ?? ''
})

watchEffect((onCleanup) => {
  itemRef.value?.addEventListener(SELECT_EVENT, onSelect)
  onCleanup(() => itemRef.value?.removeEventListener(SELECT_EVENT, onSelect))
})

onMounted(() => {
  commandStore.registerItem(item)
})

onUnmounted(() => {
  commandStore.deregisterItem(item)
})

const shouldRender = computed(() => {
  if (!shouldFilter || groupOptions.excludeFromFilter) {
    return true
  }
  const itemVisible = filtered.value.items.includes(itemId)
  return !isSearching.value ? true : itemVisible
})

const isSelected = computed(() => selected.value === props.value)

function onSelect() {
  select()
  emit('select', selected.value)
}

function select() {
  selected.value = props.value
}

return { __sfc: true,SELECT_EVENT, props, emit, shouldFilter, storeId, commandStore, selected, filtered, isSearching, itemRef, groupOptions, itemId, item, label, shouldRender, isSelected, onSelect, select, twMerge }
}

})